export const SPEED = 1.5;
export const STARTING_FRAME = 15;
